/* src/app/do-planning/remote-power/remote-power.component.css */
:host ::ng-deep .p-splitbutton.p-buttonset .p-button {
  background-color: transparent;
  color: black;
  border: none !important;
  cursor: default;
}
:host ::ng-deep .p-splitbutton.p-buttonset .p-button:hover {
  background-color: transparent;
  color: black;
  border: none !important;
  cursor: default;
}
#remote-power {
  display: flex;
  flex-direction: column;
}
.form-container {
  margin-top: 24px;
}
form {
  width: 1280px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding: 5px;
  cursor: default;
}
.wrapper2 {
  display: grid;
  grid-template-columns: 50% 50%;
  margin: 10px;
}
sup {
  vertical-align: super;
  font-size: smaller;
}
.wrapper2 div {
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding: 10px;
  margin: 5px;
  background-color: #e0e0e0;
}
label,
input[type=checkbox] {
  margin: 0 8px;
  cursor: pointer;
}
form button {
  background-color: #a8a8a8 !important;
  color: white;
  border: none;
  width: 250px;
  border-radius: 4px;
  cursor: pointer;
  height: 40px;
  transition: 0.2s ease;
}
form button:hover {
  background-color: #676767 !important;
}
.button:active {
  transform: scale(0.96);
}
.slider-value::-moz-range-thumb {
  color: #e0e0e0 !important;
  cursor: pointer;
}
.placeholder {
  color: #3f3f3f;
}
.label {
  width: 392px;
}
p {
  margin-bottom: 0 !important;
}
:host ::ng-deep .nacogr {
  background-color: #e0e0e0 !important;
  font-family: "Roboto" !important;
}
:host ::ng-deep .p-button.p-widget.p-state-default.p-button-text-only.p-state-active {
  background-color: #e0e0e0 !important;
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding-left: 35px;
  margin-bottom: 0px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  margin: 4px 0;
  -ms-user-select: none;
  user-select: none;
  height: 28px;
}
.inputcontainer {
  width: 100%;
  padding-left: 0px;
  height: 35px;
}
.inputcontainer input {
  width: 100px;
  float: right;
}
.container input[type=checkbox] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  border-radius: 5px;
}
.container:hover input ~ .checkmark {
  background-color: #ccc;
}
.container input:checked ~ .checkmark {
  background-color: #ffffff;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.container input:checked ~ .checkmark:after {
  display: block;
}
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid #8e8e8e;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.consumption-value {
  width: 100px;
  right: 24px;
  height: 26px;
}
.title-container {
  display: flex;
  justify-content: space-between;
}
.slider-value {
  -webkit-appearance: none;
  appearance: none;
  height: 6px;
  background: #a8a8a8;
  border-radius: 5px;
  outline: none;
}
.slider-value::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #858585;
  cursor: pointer;
  border: none;
}
.slider-value::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #858585;
  cursor: pointer;
  border: none;
}
.slider-value::-moz-range-track {
  background: #a8a8a8;
  height: 6px;
  border-radius: 5px;
}
/*# sourceMappingURL=remote-power.component.css.map */
